module.exports = __webpack_public_path__ + "static/media/Seaglass-logo-large.fb3fd1ed.png";